export enum TableHelperButtonEnum {
  Update = 'update',
  Delete = 'delete',
  Reply = 'reply',
  View = 'view',
  LinkToRoute = 'linkToRoute',
}
